
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import Btn from "../../shared/button/Btn"
import { showModal } from "../../../features/modal/modalSlice"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { deleteScheduledNotification } from "../../../features/admin4/admin4Slice"
import SmallSpinner from "../../shared/spinners/SmallSpinner"

const Container = styled.div`

    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;

    .modal{
        width: 550px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;

        p{
            font-size: 16px;
            font-weight: var(--font-weight-lg);
            color: ${({ theme }) => theme.mainTextColor};
            padding: 10px 60px 40px;
            line-height: 1.4;
            text-align: center;
            
            .red{
              color: var(--color-dark-red);
              font-weight: var(--font-weight-xl);
              font-size: 18px;

            }
        }

        .button-grp{
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            margin: 20px 0;
        }
    }
`
const DeleteScheduledNotificationPermissionModal = () => {
  const { modalLocation} = useSelector(state => state.modal)
  const { lockScroll, unlockScroll } = useScrollLock();

  const {scheduledNotificationItemData, isLoadingDeleteScheduledNotification} = useSelector(state => state.admin4)

  const dispatch = useDispatch()
  const location = useLocation()

           //! bu modal açıldığnda ekran ı lock lamak için
           useEffect(() => {
            lockScroll()
    
            return () => {
                unlockScroll()
            }
        }, [lockScroll, unlockScroll])
    
        //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
        useEffect(() => {
            if (location.pathname !== modalLocation) {
                dispatch(showModal(null))
            }
        }, [dispatch, location.pathname, modalLocation])


        const handleClick = () => {
            dispatch(deleteScheduledNotification(scheduledNotificationItemData.id))
            dispatch(showModal(null))
        }

  return (
    <Container onClick={()=> dispatch(showModal(null))}>
      <div className="modal" onClick={(e)=> e.stopPropagation() }>
        <p>Bildirim planını kaldırmak istediğinize emin misiniz?</p>
        <div className="button-grp">
        <Btn color="#fff" bgColor="var(--color-main)" borderColor="transparent" width={"220px"} handleClick={handleClick}>{isLoadingDeleteScheduledNotification ? <SmallSpinner size={"10px"} color={"#fff"} bgColor={"#E85446"}/> : "Kaldır"}</Btn>
        <Btn color="var(--color-main)" bgColor="transparent" borderColor="var(--color-main)" width={"220px"} handleClick={() => dispatch(showModal(null))}>Geri</Btn>
            </div>
      </div>
    </Container>
  )
}

export default DeleteScheduledNotificationPermissionModal